import { render, staticRenderFns } from "./order.vue?vue&type=template&id=be8671d0&scoped=true&"
import script from "./js/order.js?vue&type=script&lang=js&"
export * from "./js/order.js?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=be8671d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8671d0",
  null
  
)

export default component.exports